var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myheader" },
    [
      _c(
        "section",
        {
          staticClass: "logo",
          class: { minWidth: _vm.isCollapse },
          style: { background: _vm.menuConfig.menu_background_color }
        },
        [
          _c(
            "a",
            { staticClass: "logoLink", attrs: { target: "_blank", href: "" } },
            [
              _c("img", {
                attrs: { src: require("../../image/logo_w.png"), alt: "logo" }
              }),
              !_vm.isCollapse
                ? _c("span", [_vm._v("公证综合业务系统")])
                : _vm._e()
            ]
          )
        ]
      ),
      _c(
        "section",
        { staticClass: "header-content" },
        [
          _c(
            "section",
            { staticClass: "collspan dc cursor", on: { click: _vm.collspan } },
            [
              !_vm.isCollapse
                ? _c("img", {
                    attrs: { src: require("./images/close.png"), alt: "logo" }
                  })
                : _vm._e(),
              _vm.isCollapse
                ? _c("img", {
                    attrs: { src: require("./images/open.png"), alt: "logo" }
                  })
                : _vm._e()
            ]
          ),
          _c("div", { staticClass: "bread" }, [_c("BreadCrumb")], 1),
          _c("dark-birght"),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                "margin-right": "10px",
                "font-size": "small",
                color: "#5f5f5f",
                cursor: "pointer"
              },
              on: { click: _vm.goToUpdatePage }
            },
            [_vm._v("系统更新")]
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                "margin-right": "10px",
                "font-size": "small",
                color: "#5f5f5f"
              }
            },
            [_vm._v("主题选择")]
          ),
          _c("theme-picker", { staticClass: "theme-picker" }),
          _c(
            "section",
            {
              staticClass: "fullscreen cursor dc",
              on: { click: _vm.toggleFull }
            },
            [
              _c("img", {
                attrs: { src: require("./images/fullscreen.png"), alt: "logo" }
              })
            ]
          ),
          _c("img", {
            staticClass: "header-img",
            staticStyle: { cursor: "pointer" },
            attrs: { src: _vm.userInfo.headImg, alt: "" },
            on: {
              click: function($event) {
                return _vm.$refs.dialog.open()
              }
            }
          }),
          _c(
            "section",
            { staticClass: "cursor dc" },
            [
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleDropLink }
                },
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.userInfo.username) +
                        "\n          "
                    ),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "1" } }, [
                        _vm._v("\n            退出登录\n          ")
                      ]),
                      _c("el-dropdown-item", { attrs: { command: "2" } }, [
                        _vm._v("\n            修改密码\n          ")
                      ]),
                      _c("el-dropdown-item", { attrs: { command: "3" } }, [
                        _vm._v("\n            修改头像\n          ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Dialog",
        { ref: "dialog", attrs: { title: "修改头像", width: "400px" } },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "orgForm",
              attrs: { model: _vm.ruleForm, "label-width": "80px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "头像" } },
                [
                  _c("UploadImage", {
                    attrs: { imgUrl: _vm.ruleForm.headImg },
                    on: { successUpload: _vm.successUpload }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }